import styled from "styled-components";

export const Wrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;
